<template>
    <v-container grid-list-md text-xs-center>
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-card>

            <v-card-text class="px-0">
              <h2 class="font-weight-medium">Conta de Liquidação</h2>
              <!-- <img src="@/assets/anticipation.png" style="max-width: 400px;"> -->
              <h2 v-if="partner === 'establishment'" class="font-weight-light">Habilite ou desabilite a liquidação direto na sua Conta Digital {{ account.fantasy_name }}</h2>
              <h2 v-else class="font-weight-light">Habilite ou desabilite a liquidação direto na sua Conta Digital {{ partnerName }}</h2>
            </v-card-text>

            <v-list three-line>
              <v-list-tile  style="height:100%;">
                <v-list-tile-action>
                  <v-icon >account_balance_wallet</v-icon>
                </v-list-tile-action>

                <v-list-tile-content >
                  <v-list-tile-title v-if="partner === 'establishment'" class="text-capitalize font-weight-medium automatic-anticipation-title">
                    Liquidação na Conta Digital {{ account.fantasy_name }}
                    <v-icon small>help_outline</v-icon>
                  </v-list-tile-title>
                  <v-list-tile-title v-else class="text-capitalize font-weight-medium automatic-anticipation-title">
                    Liquidação na Conta Digital {{ partnerName }}
                    <v-icon small>help_outline</v-icon>
                  </v-list-tile-title>
                  <v-list-tile-sub-title class="text--primary">
                    Habilite para receber seus depósitos na Conta Digital
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title >
                    Sua liquidação digital está atualmente desativada!
                  </v-list-tile-sub-title>
                </v-list-tile-content >
                <v-list-tile-action >
                  <digital-account-liquidation-switch />
                </v-list-tile-action>
              </v-list-tile>
            </v-list>

          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'LiquidationAccount',
  created() {
    this.$store.dispatch('account/getAccount');
  },
  computed: {
    ...mapGetters({
      account: 'account/account',
      partner: 'account/partner',
      partnerName: 'account/partnerName',
    })
  },
  components: {
    DigitalAccountLiquidationSwitch: () => import('@/components/desktop/my_account/liquidation_account/DigitalAccountLiquidationSwitch.vue'),
  }

}
</script>
